import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import SearchInput from '@/components/SearchInput'

/**
 * Компонент строки поиска для таблицы URV
 * @param {Object} props
 * @param {string} props.searchInput - Текущее значение поиска
 * @param {function} props.setSearchInput - Функция установки значения поиска
 * @param {function} props.onSearch - Функция для выполнения поиска
 * @param {function} props.onOpenExport - Функция для открытия диалога экспорта
 */

const TableTopBar = ({
  searchInput = '',
  setSearchInput = () => {},
  onSearch = () => {},
  onOpenExport = () => {} 
}) => {
  const { t } = useTranslation();
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearch()
    }
  }

  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1
      }}
    >
      <SearchInput
        placeholder={t('search_by_name_or_iin')}
        value={searchInput}
        onChange={(value) => setSearchInput(value)}
        onKeyDown={handleKeyDown}
        delay={0}
      />
      <Button
        variant="outlined"
        size="small"
        onClick={onSearch}
      >
        { t('search') }
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={onOpenExport}
      >
        { t('export') }
      </Button>
    </Box>
  )
}

export default TableTopBar
